import React from 'react';
import PropTypes from 'prop-types';
import Markdown from '../../components/Markdown';
import Page from '../../components/Page.js';
import ContentContainer from '../../components/ContentContainer.js';

const ContentPage = ({content}) => {
  if (!content) return null;

  return (
    <Page title={content.title}>
      <ContentContainer title={content.title}>
        <Markdown content={content.body}/>
      </ContentContainer>
    </Page>
  );
};

ContentPage.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
  })
};

export default ContentPage;
